const defaultState = {
	selectOptions: {
		plants: [],
		shopCds: [],
		serverNames: [],
		serviceKinds: [],
		pgmTypes: [],
		pgmIds: [],
		mainFlgs: [],
		exeEnvs: [],
		lines: []
	},

	searchParams: {
		plantCd: null,
		shopCd: 'ALL',
		serverName: 'ALL',
		serviceKind: 'ALL',
		pgmType: 'ALL',
		pgmId: 'ALL'
	},

	pagingInfo: {
		currentPage: 1,
		pageUnit: 20
	},

	popupParams: {
		type: '',
		show: false,
		selectedRow: {}
	},

	programs: []
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
